{
  "name": "church-services-ui",
  "version": "1.0.0",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "build": "set NODE_OPTIONS=--openssl-legacy-provider &&  ng build --aot",
    "deploy": "set NODE_OPTIONS=--openssl-legacy-provider && ng build --configuration production && node scripts/deploy-web.cjs production",
    "qa": "set NODE_OPTIONS=--openssl-legacy-provider && ng build --configuration staging && node scripts/deploy-web.cjs staging",
    "test": "set NODE_OPTIONS=--openssl-legacy-provider &&  ng test",
    "lint": "set NODE_OPTIONS=--openssl-legacy-provider &&  ng lint",
    "e2e": "set NODE_OPTIONS=--openssl-legacy-provider &&  ng e2e"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "~20.3.19",
    "@angular/cdk": "^20.0.0",
    "@angular/common": "~20.3.19",
    "@angular/compiler": "~20.3.19",
    "@angular/core": "~20.3.19",
    "@angular/fire": "^20.0.0",
    "@angular/forms": "~20.3.19",
    "@angular/localize": "~20.3.19",
    "@angular/material": "^20.0.0",
    "@angular/material-moment-adapter": "^20.2.14",
    "@angular/platform-browser": "~20.3.19",
    "@angular/platform-browser-dynamic": "~20.3.19",
    "@angular/router": "~20.3.19",
    "@angular/service-worker": "~20.3.19",
    "@capacitor/android": "^7.4.4",
    "@capacitor/browser": "^7.0.2",
    "@capacitor/core": "^7.4.3",
    "@fortawesome/fontawesome-free": "^5.15.1",
    "@googlemaps/markerclustererplus": "^1.2.10",
    "@ng-bootstrap/ng-bootstrap": "^19.0.1",
    "@popperjs/core": "^2.11.8",
    "@techiediaries/ngx-textarea-autosize": "^1.3.0",
    "@tinymce/tinymce-angular": "^9.1.1",
    "aes-js": "^3.1.2",
    "angular-froala-wysiwyg": "^3.2.7",
    "bootstrap": "4.6",
    "capacitor-ios-autofill-save-password": "^5.0.0",
    "capacitor-plugin-send-intent": "^0.0.2",
    "chart.js": "^4.0.0",
    "crypto-js": "^4.1.1",
    "firebase": "^12.12.0",
    "formBuilder": "^3.7.3",
    "google-maps": "^4.3.3",
    "html2canvas": "^1.4.1",
    "html2pdf.js": "^0.9.3",
    "jquery": "^3.7.1",
    "jquery-ui": "^1.13.1",
    "jspdf": "^2.5.1",
    "moment": "^2.29.1",
    "ng-multiselect-dropdown": "^1.0.0",
    "ng2-charts": "^5.0.0",
    "ng2-search-filter": "^0.5.1",
    "ngx-cookie": "^5.0.0",
    "ngx-pagination": "^6.0.3",
    "popper.js": "^1.16.1",
    "qrcode": "^1.5.4",
    "rxjs": "7.8",
    "save": "^2.4.0",
    "tinymce": "^8.4.0",
    "tslib": "^2.0.0",
    "zone.js": "~0.15.1"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "~20.3.24",
    "@angular/cli": "~20.3.24",
    "@angular/compiler-cli": "~20.3.19",
    "@capacitor/cli": "^7.4.4",
    "@types/google.maps": "^3.48.2",
    "@types/jasmine": "~3.5.0",
    "@types/jasminewd2": "~2.0.3",
    "@types/node": "^12.20.55",
    "@types/qrcode": "^1.5.6",
    "codelyzer": "^6.0.0",
    "fuzzy": "^0.1.3",
    "inquirer": "^6.2.2",
    "inquirer-autocomplete-prompt": "^1.0.1",
    "jasmine-core": "~3.8.0",
    "jasmine-spec-reporter": "~5.0.0",
    "karma": "~6.4.4",
    "karma-chrome-launcher": "~3.1.0",
    "karma-coverage-istanbul-reporter": "~3.0.2",
    "karma-jasmine": "~4.0.0",
    "karma-jasmine-html-reporter": "^1.5.0",
    "open": "^7.0.3",
    "protractor": "~7.0.0",
    "ts-node": "~8.3.0",
    "tslint": "~6.1.0",
    "typescript": "~5.8.3"
  },
  "browser": {
    "crypto": false
  }
}
